<template>
  <div>
    <zj-layout-container v-loading="loading" :element-loading-text="loadingText">
      <zj-layout-header>
        <div class="listtitle">厕所设备</div>
        <el-form class="zj-search-form" ref="form" :model="form" :label-width="labelWidth">
          <el-form-item label="名称" prop="deviceName">
            <el-input
              v-model="name"
              placeholder="请输入名称"
            ></el-input>
          </el-form-item>
          <!-- <el-form-item label="区域">
            <el-select v-model="RegionId" placeholder="请选择">
              <el-option key label="全部" value></el-option>
              <el-option
                v-for="item in EqRegionArr"
                :key="item.RegionId"
                :label="item.RegionName"
                :value="item.RegionId"
              ></el-option>
            </el-select>
          </el-form-item> -->
          <el-form-item label class="right">
            <el-button @click="onSearch">查 询</el-button>
            <el-button @click="onCancel">清 理</el-button>
          </el-form-item>
        </el-form>
        <el-divider>
          
        </el-divider>
      </zj-layout-header>
      <zj-layout-main>
        <div class="zj-button-bar">
           <!-- <el-button size="mini" @click="onAdd">添 加</el-button> -->
        </div>
        <div class="zj-layout-main-content bgcolor scrollable">
          <div class="zj-table-container">
            <el-table :data="tableData" ref="multipleTable" border style="width: 100%" fixed>
              <el-table-column type="index" label="序号" width="80" align="center"></el-table-column>
              <el-table-column prop="tId" label="厕所编号"></el-table-column>
              <el-table-column prop="name" label="名称"></el-table-column>
              <el-table-column prop="maleNum" label="男厕间数"></el-table-column>
              <el-table-column prop="femaleNum" label="女厕间数"></el-table-column>
              <el-table-column prop="mixedNum" label="混合厕间数"></el-table-column>
              <el-table-column prop="thirdNum" label="第三厕间数"></el-table-column>
              <el-table-column prop="status" label="状态"></el-table-column>
              <el-table-column label="操作" width="120" align="center">
                <template slot-scope="scope">
                  <template>
                    <el-button
                      @click="queryDetail(scope.$index, scope.row)"
                      type="text"
                      size="small"
                    >查看</el-button>
                     <el-button
                      @click="editDetail(scope.$index, scope.row)"
                      type="text"
                      size="small"
                    >编辑</el-button>
                    <!-- <el-button
                      @click="deleteClick(scope.$index, scope.row)"
                      type="text"
                      size="small"
                    >删除</el-button> -->
                  </template>
                </template>
              </el-table-column>
            </el-table>
          </div>
        </div>
      </zj-layout-main>
      <zj-layout-footer>
        <el-pagination
          @size-change="handleSizeChange"
          @current-change="handleCurrentChange"
          :current-page="currentPage"
          :page-sizes="[10, 20, 50, 100]"
          :page-size="pageSize"
          layout="total, sizes, prev, pager, next, jumper"
          background
          :total="total"
        ></el-pagination>
      </zj-layout-footer>
    </zj-layout-container>
  </div>
</template>

<script>
import { queryToilet } from "../../../apis/src/Query.js";
export default {
  name: "SmartTolietManagerView",
  controller: "UI",
  action: "SmartTolietManagerView",
  data() {
    return {
      loading: false,
      loadingText: '加载中...',
      currentPage: 1,
      pageSize: 20,
      total: 0,
      tableData: [],
      name: "",
      EqRegionArr: [],
      RegionId:''
    };
  },
  created: function() {
  },
  mounted: function() {
    this.search();
  },
  methods: {
    search() {
      let data = {
        name: this.name,
        size: this.pageSize,
        page: this.currentPage
      };
      this.loading = true;
      queryToilet(data).then((r) =>{
        if(r.code == 0){
          this.tableData = r.data;
          this.total = r.count;
          this.loading = false;
        }else{
          this.$message({
            type: "error",
            message: r.msg
          });
        }
      })
    },
    //查看
    queryDetail(index, row) {
      this.$router.push({
        path: "/plugin/smartToilet/ui/SmartTolietManagerInfo",
        query: { entityCode: row.entityCode, type: "query" }
      });
    },
     //编辑
    editDetail(index, row) {
      this.$router.push({
        path: "/plugin/smartToilet/ui/SmartTolietManagerInfo",
        query: { entityCode: row.entityCode, type: "edit" }
      });
    },
    // 点击查询按钮
    onSearch() {
      this.currentPage = 1;
      this.search();
    },
    clearsearch() {
      this.name = "";
      this.RegionId = "";
    },
    // 点击取消按钮
    onCancel() {
      this.clearsearch();
      this.search();
    },
    handleSizeChange(val) {
      this.pageSize = val;
      this.search();
    },
    handleCurrentChange(val) {
      this.currentPage = val;
      this.search();
    }
  }
};
</script>
